import { z } from 'zod'
import { requiredString } from '../../primitives/string'
import { MESSAGES } from '../../utils/messages'

/**
 * Subtipo de inmueble (type-property) — fuente única de verdad para la
 * validación del API (nestjs-zod `createZodDto`) y del formulario web
 * (RHF + zodResolver).
 *
 * El código es único POR PROYECTO (no global): dos proyectos pueden tener
 * cada uno su subtipo "APT". Se recorta (`trim`) porque la data histórica
 * traía códigos con espacios colgantes (import VARENA).
 */

// ObjectId de Mongo serializado (24 hex): el wire actual identifica el
// proyecto por ObjectId; no cambiar hasta un pase de contrato v2.
const objectIdString = z
  .string({ required_error: MESSAGES.REQUIRED, invalid_type_error: MESSAGES.REQUIRED })
  .regex(/^[a-f0-9]{24}$/i, 'Identificador inválido')

export const CreateTypePropertyInputSchema = z.object({
  project: objectIdString,
  code: requiredString()
    .transform((value) => value.trim())
    .pipe(requiredString()),
  name: z
    .string()
    .transform((value) => value.trim())
    .optional(),
  active: z.boolean().optional()
})

export const UpdateTypePropertyInputSchema = CreateTypePropertyInputSchema.partial()

export type CreateTypePropertyInput = z.infer<typeof CreateTypePropertyInputSchema>
export type UpdateTypePropertyInput = z.infer<typeof UpdateTypePropertyInputSchema>
